export default [
    {
		path: '/hash-tags',
		name: 'HashTags',
		component: () => import('@/views/hashTag/HashTags.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'hashtags'], ['manage', 'hashtags']]
		}
	},
]